import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import type { Role } from '../types/roles.type';

export type GetListRoleParams = Partial<ApiParamsDefault>;
export type GetListRoleResponse = ApiResponsePagination<Role>;

export const getListRole = async (
  params?: GetListRoleParams
): Promise<GetListRoleResponse> => {
  const url = '/role';

  return apiClient.get(url, { params });
};

export const GET_LIST_ROLE_QUERY_KEY = 'get-list-roles';

export const getListRoleQueryOptions = (params?: GetListRoleParams) =>
  queryOptions({
    queryKey: [GET_LIST_ROLE_QUERY_KEY, params],
    queryFn: () => getListRole(params),
  });
